/**
 * mc-utils - a grab bag of somewhat useful utility functions
 *
 * Copyright (c) 2019. Mirae Climate Co., Ltd.
 */

import µ from "../../earth/1.0.0/micro";
import products from "../../earth/1.0.0/products";

export default (function () {
    function roundRect(ctx, x, y, width, height, radius, fill, stroke) {
        if (typeof stroke === "undefined") {
            stroke = true;
        }
        if (typeof radius === "undefined") {
            radius = 5;
        }
        ctx.beginPath();
        ctx.moveTo(x + radius, y);
        ctx.lineTo(x + width - radius, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
        ctx.lineTo(x + width, y + height - radius);
        ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
        ctx.lineTo(x + radius, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
        ctx.lineTo(x, y + radius);
        ctx.quadraticCurveTo(x, y, x + radius, y);
        ctx.closePath();
        if (stroke) {
            ctx.stroke();
        }
        if (fill) {
            ctx.fill();
        }
    }

    function hpaToHeight(p) {
        p = p === "surface" ? 1013.25 : parseInt(p);
        // p = hpa
        let p0 = 1013.25; //hpa = 1013.25mbar
        return 44330 * (1 - Math.pow((p / p0), 0.19));
    }

    function isTruthy(x) {
        return !!x;
    }

    function classNames(classes) {
        return Object.entries(classes)
            .filter(([key, value]) => value)
            .map(([key, value]) => key)
            .join(' ');
    }

    function loadCrossSectionData(params) {
        let path = [µ.crossSection, params].join("/");
        return µ.loadJson(path).then(function (crossSectionData) {
            return crossSectionData;
        });
    }

    function loadAreaMeanData(params) {

        let path = [µ.areaMean, params].join("/");

        return µ.loadJson(path).then(function (crossSectionData) {
            return crossSectionData;
        });
    }

    // function loadAreaMeanData(date, predictDate, productType, predictType, predictPeriod, productPeriod,
    // 	ensType, type, surface, level, diffDate, diffType, dataType, crossSection) {

    // 	let file = [predictDate, productType, predictType, predictPeriod, productPeriod,
    // 		ensType, products.platformType(type), surface, level, diffDate, diffType, dataType, crossSection.replace(/-/gi, "^"), "areamean"].filter(µ.isValue).join("-");
    // 	let path = [products.getDataType(dataType), date, file].join("/");

    // 	// 유선함수, 속도포텐셜
    // 	const dataType = µ.indexOf(["wp", "wk"], type) ? "cif" : "glosea5";
    // 	if (µ.indexOf(["wp", "wk"], type)) {  // p, k (유선함수, 속도포텐셜)
    // 		const ciType = type + (level !== null ? level.substring(0, level.length - 3) : "");
    // 		path = [products.getDataType(dataType), µ.ymdRedelimit(dir, "/", ""), predictType, predictPeriod, productPeriod, ciType, level, predictDate].join("/");
    // 	}

    // 	return µ.loadJson(path).then(function (crossSectionData) {
    // 		return crossSectionData;
    // 	});
    // }

    function loadClimateIndexData(initialDate, predictType, predictPeriod, productPeriod, climateIndex, mjoType, callback) {
        // /api/ci/20200525/fcst/1mon/week/enso
        // /api/ci/20200525/fcst/1mon/week/mjo/forecast
        const path = [products.getDataType('ci'), initialDate, predictType, predictPeriod, productPeriod, climateIndex, mjoType].join("/");
        µ.loadJson(path).then(data => callback(data));
    }

    function loadClimateIndexTimeSeriesData(initialDate, callback) {
        // /api/cits/20200525
        µ.loadJson([products.getDataType('cits'), initialDate].join("/")).then(data => callback(data));
    }

    function loadClimateIndexSSWData(initialDate, callback) {
        // /api/cissw/20200907
        µ.loadJson([products.getDataType('cissw'), initialDate].join("/")).then(data => callback(data));
    }

    return {
        roundRect: roundRect,
        hpaToHeight: hpaToHeight,
        isTruthy: isTruthy,
        classNames: classNames,
        loadCrossSectionData: loadCrossSectionData,
        loadAreaMeanData: loadAreaMeanData,
        loadClimateIndexData: loadClimateIndexData,
        loadClimateIndexTimeSeriesData: loadClimateIndexTimeSeriesData,
        loadClimateIndexSSWData: loadClimateIndexSSWData,
    };

})();